// CampaignPage.jsx (yalnızca farkları göstermek yerine tüm dosyayı güncel veriyorum)
import React, { useEffect, useState } from 'react';
import { Backdrop, Card, CircularProgress, Stack, Typography } from '@mui/material';
import moment from 'moment';
import { Helmet } from 'react-helmet-async';
import { toast } from 'react-toastify';
import AddEntityButton from 'src/components/shared/AddEntityButton';
import DynamicTable from 'src/components/shared/DynamicTable';
import AddEditCampaignModal from 'src/modals/AddEditCampaignModal';
import Services from 'src/services/Services';
import EditButton from 'src/components/shared/EditButton';
import { useLocalization } from 'src/context/LocalizationContext';

// YENİ
import QuestionTypeManagerModal from 'src/modals/QuestionTypeManagerModal';

export default function CampaignPage() {
    const { language } = useLocalization();
    const parsedUser = JSON.parse(localStorage.getItem('user'));

    const [loading, setLoading] = useState(true);
    const [campaignList, setCampaignList] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedCampaign, setSelectedCampaign] = useState();

    // YENİ: Soru Tipi Modali
    const [questionModalOpen, setQuestionModalOpen] = useState(false);

    let TABLE_HEAD = [
        { id: 'title', label: language.commons.column.campaign_name },
        { id: 'description', label: language.commons.column.explain, format: (value) => truncatedText(value) },
        { id: 'createdDateTime', label: language.commons.column.created_date, format: (value) => formatDate(value) },
        { id: 'start', label: language.commons.labels.start_date, format: (value) => formatDate(value) },
        { id: 'end', label: language.commons.labels.end_date, format: (value) => formatDate(value) },
        {
            id: 'status',
            label: language.commons.status,
            format: (value, row) => {
                const style = getRowStyle(row);
                const isExpired = style.backgroundColor === '#eb4034';
                if (isExpired) {
                    return <span style={{ color: '#eb4034', fontWeight: 600 }}>Süresi Geçti</span>;
                }
                const label = value === "1" ? language.commons.labels.active : language.commons.labels.passive;
                return <span>{label}</span>;
            }
        },
        { id: 'operation', label: '', format: (value, row) => (<EditButton onClick={() => handleCampaignSelect(row)} />) },
    ];

    const formatDate = (date) => moment.unix(date).format('DD.MM.YYYY');

    function removeHtmlTags(str) {
        return str.replace(/<\/?[^>]+(>|$)/g, "");
    }

    function truncatedText(text) {
        let newText = removeHtmlTags(text);
        const maxLength = 20;
        if (newText.length > maxLength) {
            return <span>{newText.substring(0, maxLength)}...</span>;
        }
        return <span style={{ width: '35%' }}>{newText}</span>;
    }

    const getRowStyle = (campaign) => {
        const endDate = moment.unix(campaign.end);
        const today = moment();
        const daysDiff = endDate.diff(today, 'days');
        if (daysDiff <= 0) return { backgroundColor: '#eb4034', color: '#fff' };
        if (daysDiff <= 3) return { backgroundColor: '#eb9634', color: '#fff' };
        return {};
    };

    const handleCampaignAdd = () => setModalOpen(true);
    const handleCloseModal = () => setModalOpen(false);

    const getCampaigns = (token) => {
        setLoading(true);
        Services.GetCampaigns(token)
            .then((res) => {
                if (res.data.status) {
                    setCampaignList(res.data.result);
                } else {
                    toast.error("Kampanya bulunamadı.");
                }
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    };

    useEffect(() => {
        getCampaigns(parsedUser.token);
    }, []);

    const handleCampaignSelect = (campaign) => {
        setModalOpen(true);
        setSelectedCampaign(campaign);
    };

    return (
        <>
            <Helmet>
                <title>{language.campaign_page.titles.site_title}</title>
            </Helmet>

            <Stack style={{ paddingInline: '25px' }}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        {language.campaign_page.titles.title}
                    </Typography>
                    <Stack direction="row" gap={1}>
                        <AddEntityButton
                            label="Soru Tipi Ekle"
                            icon={'material-symbols:quiz-outline'}
                            onClick={() => setQuestionModalOpen(true)}
                        />
                        <AddEntityButton
                            label={language.commons.labels.add_campaing}
                            icon={'ic:outline-add'}
                            onClick={handleCampaignAdd}
                        />
                    </Stack>
                </Stack>

                <Card>
                    {loading ? (
                        <Backdrop sx={{ color: '#fff', zIndex: 2, height: '100%' }} open={loading}>
                            <CircularProgress color="inherit" />
                        </Backdrop>
                    ) : (
                        <DynamicTable
                            data={campaignList}
                            headers={TABLE_HEAD}
                            isOrdered={true}
                            initialOrder={"createdDateTime"}
                            initalOrderDirection={"desc"}
                            rowOnClick={handleCampaignSelect}
                        />
                    )}
                </Card>
            </Stack>

            <AddEditCampaignModal
                open={modalOpen}
                onClose={handleCloseModal}
                getCampaigns={getCampaigns}
                campaign={selectedCampaign}
                setSelectedCampaign={setSelectedCampaign}
            />

            {/* Soru Tipi Yönetimi */}
            <QuestionTypeManagerModal
                open={questionModalOpen}
                onClose={() => setQuestionModalOpen(false)}
            />
        </>
    );
}